import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const PricingSettingsPage = loadable(
  async () => import("~/features/pricing-settings/pages/PricingSettingsPage"),
  { fallback: <></> },
)

export const pricingSettingsRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.pricingSettings,
    element: <PricingSettingsPage />,
  },
]
